// frontend/src/pages/portfolio/sections/RolesSection.tsx
import React from "react";
import { BarChart3, Clock, Users } from "lucide-react";
import SectionEyebrow from "../components/SectionEyebrow";
import {
  cardHover,
  container,
  sectionHeading,
  sectionLede,
  sectionReveal,
} from "../components/styles";

const RolesSection: React.FC = () => {
  return (
    <section
      id="roles"
      className="border-t border-primary-200/30 bg-primary-50/30 py-16 sm:py-20"
      aria-labelledby="roles-heading"
    >
      <div className={container}>
        <div className={`max-w-2xl ${sectionReveal}`}>
          <SectionEyebrow icon={Users}>Roles</SectionEyebrow>
          <h2 id="roles-heading" className={`mt-4 ${sectionHeading}`}>
            Built for admins and their teams
          </h2>
          <p className={sectionLede}>
            Permissions follow real-world responsibility — no mystery doors in
            the sidebar.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          <article className={`rounded-2xl border border-gray-200 bg-white p-6 shadow-card sm:p-8 ring-1 ring-primary-900/[0.04] ${cardHover}`}>
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-50 text-primary-800 ring-1 ring-primary-100">
              <BarChart3 className="h-6 w-6" aria-hidden />
            </span>
            <h3 className="mt-6 font-display text-xl font-semibold text-primary-950">
              Organization admin
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-gray-600">
              Manages employees, reviews time and status, uses dashboards and
              calendar views, and adjusts org-level options such as billing and
              optional browser tracking.
            </p>
          </article>
          <article className={`rounded-2xl border border-gray-200 bg-white p-6 shadow-card sm:p-8 ring-1 ring-primary-900/[0.04] ${cardHover}`}>
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-50 text-primary-800 ring-1 ring-primary-100">
              <Clock className="h-6 w-6" aria-hidden />
            </span>
            <h3 className="mt-6 font-display text-xl font-semibold text-primary-950">
              Employee
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-gray-600">
              Clock in and out, maintain session history, update availability
              status, and use billing entry tools when your org enables them.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default RolesSection;
